import { useMemo } from "react";
import { asset } from "../lib/api";

// A tiled mosaic of wedding photos that fills its container as a background,
// with children (the business name) rendered on top.
export const WeddingMosaic = ({ images = [], children, tiles = 60, overlay = 0.72 }) => {
  const cells = useMemo(() => {
    if (!images.length) return [];
    const shuffled = [...images];
    return Array.from({ length: tiles }, (_, i) => shuffled[i % shuffled.length]);
  }, [images, tiles]);

  return (
    <div className="relative w-full h-full overflow-hidden bg-obsidian" data-testid="wedding-mosaic">
      <div className="absolute inset-0 grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-8 gap-1">
        {cells.map((src, i) => (
          <div key={i} className="relative aspect-square overflow-hidden animate-fade-in" style={{ animationDelay: `${(i % 10) * 80}ms` }}>
            <img src={asset(src)} alt="" loading="lazy"
              className="absolute inset-0 w-full h-full object-cover opacity-80 hover:opacity-100 transition-opacity duration-700" />
          </div>
        ))}
      </div>
      <div className="absolute inset-0" style={{ background: `rgba(8,8,10,${overlay})` }} />
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 45%, transparent 20%, rgba(8,8,10,0.85) 80%)" }} />
      <div className="absolute inset-0 flex items-center justify-center px-6">{children}</div>
    </div>
  );
};
